/**
 * The payroll system a screen talks to (#187): PowerOffice Go and Tripletex answer the same routes in the
 * same shapes (backend/services/payrollPeople.js), so Koble ansatte og lønnsarter and Lønn og kontrakt
 * serve both. `key` is the field a contract change carries the system's value in.
 */
import { useEffect } from 'react';

/**
 * The welcome's «Koble til» (#191) lands on the system's panel: `/innstillinger/lonn#tripletex`
 * scrolls it into view once its status has loaded, since the panel sits at the foot of Lønn.
 */
export function useLandOn(id: string, ready: boolean) {
  useEffect(() => {
    if (ready && window.location.hash === `#${id}`)
      document.getElementById(id)?.scrollIntoView({ block: 'start' });
  }, [id, ready]);
}

export interface PayrollSystem {
  key: 'poweroffice' | 'tripletex';
  base: string;
  /** the name in a sentence: «Henter fra PowerOffice …» */
  short: string;
}
export const POWEROFFICE: PayrollSystem = {
  key: 'poweroffice',
  base: '/admin/poweroffice',
  short: 'PowerOffice',
};
export const TRIPLETEX: PayrollSystem = { key: 'tripletex', base: '/admin/tripletex', short: 'Tripletex' };
